module.exports = __webpack_public_path__ + "media/src/images/forgot-pass-3094d464fac88a080b5c553fe1ccb27a.png";